import { Component } from 'react';
import { Alert, Button, Card, Image, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Cultured, DarkElectricBlue, GammaBlue, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
import { getUrlParam } from '../../helpers/general_helpers';
import axios from 'axios';
import GetIcon from '../../helpers/icon_helper';
import PaymentGatewayJisHyperpay from './PaymentGatewayJisHyperpay';
const apiURL = process.env.REACT_APP_API_URL;
class PaymentGateway extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageReady: false,
            isPageError: false,
            params: null,
            tenant_id: null,
            rData: null
        };
    }

    componentDidMount() {
        let getUrlParamData = getUrlParam()
        if (getUrlParamData.p || getUrlParamData.rData) {
            let data = getUrlParamData.p ? JSON.parse(decodeURIComponent(atob(getUrlParamData.p))) : null;
            let tenant_id = getUrlParamData.tenant_id ? getUrlParamData.tenant_id : null;
            let rData = getUrlParamData.rData ? JSON.parse(decodeURIComponent(atob(getUrlParamData.rData)
            )) : null;
            this.setState({ params: data, tenant_id, rData }, () => this.getDetails())
        } else {
            this.setState({ isPageReady: true, isPageError: true })
        }
    }

    getDetails = () => {
        try {
            axios.get(apiURL + 'payment-gateway/get-details', {
                params: {
                    center_id: this.state.params.center_id,
                    child_id: this.state.params.child_id,
                    parent_id: this.state.params.parent_id,
                    tenant_id: this.state.tenant_id,
                }
            }).then((res) => {
                if (res) {
                    let resData = res.data
                    if (resData.type) {
                        this.setState({ params: { ...this.state.params, ...resData.data }, isPageReady: true })
                    } else {
                        this.setState({ isPageReady: true, isPageError: true })
                    }
                }
            });
        } catch (e) {
            console.log('e', e);
        }
    }

    renderCenterPaymentPage = () => {
        // PaymentGatewayJisHyperpay
        // PaymentCenterDefault
        // PaymentNotConfigured
        let { params, isPageReady, isPageError, tenant_id } = this.state
        if (params.center_id == 2) {
            return <PaymentCenterDefault params={params} tenant_id={tenant_id} />
        } else if (params.center_id == 83) {
            return <PaymentGatewayJisHyperpay params={params} tenant_id={tenant_id} />
        } else {
            return <PaymentNotConfigured params={params} tenant_id={tenant_id} />
        }
    }

    render() {
        let { params, isPageReady, isPageError, rData } = this.state
        return (
            <div style={{ backgroundColor: Cultured, height: '100vh', width: '100%', overflow: 'hidden' }}>
                <div className='d-flex flex-column align-items-center justify-content-center' style={{ flex: 1, fontSize: 14 }}>

                    {/* IF RETURN DATA FROM SERVER AFTER PAYMENT */}
                    {(rData) &&
                        <div className='m-3'>
                            <Alert variant={rData.messageType}>
                                <strong>{t(rData.messageTitle)}: </strong>{t(rData.message)}
                                {!rData.type &&
                                    <Button variant={rData.messageType} className='mx-2' onClick={() => window.open(rData.getCurrentURL)}>Retry</Button>
                                }
                            </Alert>
                        </div>
                    }

                    {/* OPEN LINK FOR PAYMENT */}
                    {(!rData && !isPageReady && !isPageError) &&
                        <div className='m-3'>
                            <Spinner animation='grow' variant='dark' />
                        </div>
                    }
                    {(!rData && isPageReady && isPageError) &&
                        <div className='m-3'>
                            <Alert variant='danger'>{t('Incorrect details, please contact admin')}</Alert>
                        </div>
                    }
                    {(!rData && isPageReady && !isPageError) &&
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ width: '100%', height: '100%' }}>
                            {/* FOR EACH CENTER COPY AND PASTE PaymentCenterDefault IN A NEW FILE IN SAME FOLDER with the name "PaymentCenter`center_id`" and add a condition here*/}
                            {this.renderCenterPaymentPage()}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps())(PaymentGateway);


class PaymentNotConfigured extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        let { params } = this.props
        return (
            <Card className='border-0' style={{ borderRadius: '20px', marginTop: 20, width: '90%' }}>
                <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                    <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>Payment</div>
                </Card.Header>
                <Card.Body>
                    <Alert variant='danger'>
                        <GetIcon icon="LuBadgeAlert" style={{ fontSize: 20, marginRight: 10 }} />
                        Payment Gateway not configured, Contact Educore.
                    </Alert>
                </Card.Body>
                <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                </Card.Footer>
            </Card>
        )
    }
}

class PaymentCenterDefault extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        let { params } = this.props
        return (
            <Card className='border-0' style={{ borderRadius: '20px', marginTop: 20, width: '90%' }}>
                <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                    <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>Payment</div>
                </Card.Header>
                <Card.Body>
                    <Table borderless striped>
                        <thead>
                            <tr>
                                <th style={{ fontSize: 16, textAlign: 'center', color: DarkElectricBlue }} colSpan={2}>Summary</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th style={{ textAlign: 'center' }}>Parent Name</th>
                                <td style={{ textAlign: 'center' }}>{params.parent_name}</td>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center' }}>Student Name</th>
                                <td style={{ textAlign: 'center' }}>{params.child_name}</td>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center' }}>Amount Due</th>
                                <td style={{ textAlign: 'center' }}>{params.currencycode}{' '}{params.balance}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            {/* PAYMENT METHOD ICONS */}
                            <tr>
                                <td colSpan={2} style={{ textAlign: 'center', }}>
                                    <div className='d-flex flex-row align-items-center justify-content-center'>
                                        <Image src={require('../../assets/payment-methods/american-express.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/mada.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/mastercard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/visacard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </Card.Body>
                <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                    <Button variant='primary' style={{ width: '100%' }}>
                        <div className='d-flex flex-row justify-content-center align-content-center'>
                            <div className='mx-1'>{t('Pay Now')}</div>
                            <div className='mx-1' style={{ fontWeight: 600 }}>{params.currencycode}</div>
                            <div className='mx-1 px-2' style={{ backgroundColor: White, borderRadius: 20, color: GammaBlue, fontWeight: 600 }}>{params.balance}</div>
                        </div>
                    </Button>
                </Card.Footer>
            </Card>
        )
    }
}
